import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';
import { ProjectProgressTimeInfo } from './ProjectProgressTimeInfo';
import { ProjectProgressMilestones } from './ProjectProgressMilestones';
import { ProjectProgressActivities } from './ProjectProgressActivities';

interface ProjectProgressSidebarProps {
  data: any;
}

export function ProjectProgressSidebar({ data }: ProjectProgressSidebarProps) {
  const statsData = [
    { name: 'Hoàn thành', value: 10, color: '#10b981' },
    { name: 'Đang thực hiện', value: 12, color: '#3b82f6' },
    { name: 'Chưa bắt đầu', value: 8, color: '#94a3b8' },
    { name: 'Quá hạn', value: 2, color: '#f43f5e' },
  ];

  return (
    <div className="space-y-6">
      {/* Tiến độ tổng thể (Donut) */}
      <DonutLegendChart
        title="Tiến độ tổng thể"
        centerValue="45%"
        centerLabel="Đang thực hiện"
        data={statsData}
        total={32}
      />

      {/* Thông tin thời gian */}
      <ProjectProgressTimeInfo info={data.timeInfo} />

      {/* Các mốc quan trọng */}
      <ProjectProgressMilestones milestones={data.milestones} />

      {/* Hoạt động liên quan */}
      <ProjectProgressActivities activities={data.activities} />
    </div>
  );
}
